<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดการบัตร (โควต้า)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ออก / แก้ไข / ยกเลิกบัตรจอดตามโควต้า Platform — แสดงเฉพาะบัตรที่ผูกโควต้า
      </p>
      <p *ngIf="clientScope.isRestricted()" class="text-xs text-amber-700 dark:text-amber-400 mt-2 flex items-center gap-1">
        <span class="material-icons text-sm">store</span>
        แสดงเฉพาะบัตรร้าน:
        <span class="font-bold">{{ clientScope.scopeSummaryLabel() }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div class="relative min-w-[200px]">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-amber-500 text-[20px]">place</span>
        <select *ngIf="siteState.sites().length > 1" [ngModel]="selectedSiteId" (ngModelChange)="onSiteChange($event)"
          class="w-full pl-10 pr-4 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-sm font-bold rounded-xl text-slate-800 dark:text-amber-100 outline-none focus:ring-2 focus:ring-amber-200 h-[46px]">
          <option *ngFor="let site of siteState.sites()" [ngValue]="site.id">{{ site.name }}</option>
        </select>
        <div *ngIf="siteState.sites().length <= 1"
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm font-bold rounded-xl text-slate-700 dark:text-slate-200 h-[46px] flex items-center">
          {{ siteState.selectedSite()?.name || '—' }}
        </div>
      </div>
      <button (click)="onRefresh()" [disabled]="isLoading()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px] disabled:opacity-50">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="openIssue()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons">add_card</span> ออกบัตร
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/50 flex flex-col gap-4">
      <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">badge</span>
          บัตร Platform Quota
          <span class="text-xs font-semibold text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
            {{ siteState.selectedSite()?.name || '—' }}
          </span>
        </h3>
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:max-w-3xl">
          <select [ngModel]="searchField()" (ngModelChange)="searchField.set($event)"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let opt of searchFieldOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="relative flex-1 flex">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" placeholder="ค้นหา..." [ngModel]="searchText()"
              (ngModelChange)="searchText.set($event)" (keyup.enter)="onSearch()"
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
          </div>
          <button (click)="onSearch()"
            class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all">ค้นหา</button>
          <button *ngIf="searchText()" (click)="clearSearchText()"
            class="px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold rounded-xl transition-all">ล้าง</button>
        </div>
      </div>

      <div class="flex flex-col xl:flex-row gap-3">
        <div class="relative min-w-[220px] xl:min-w-[260px] z-30">
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg">store</span>
            <input type="text" [(ngModel)]="clientSearchText" (focus)="openClientDropdown()" (input)="onClientSearchInput()"
              (blur)="closeClientDropdown()" placeholder="กรองร้าน (ว่าง = ทั้งหมด)"
              class="w-full pl-10 pr-9 py-2 bg-transparent border-none text-sm font-medium focus:outline-none">
            <button *ngIf="filterClientId" type="button" (mousedown)="$event.preventDefault(); clearClientFilter()"
              class="absolute right-2 text-slate-400 hover:text-rose-500">
              <span class="material-icons text-lg">close</span>
            </button>
          </div>
          <button *ngIf="isClientDropdownOpen" type="button" class="fixed inset-0 z-20 cursor-default"
            (click)="closeClientDropdown()"></button>
          <div *ngIf="isClientDropdownOpen"
            class="absolute top-full mt-2 left-0 right-0 max-h-56 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-40 custom-scrollbar">
            <button *ngFor="let c of clientFilterOptions" type="button" (mousedown)="$event.preventDefault(); selectClient(c)"
              class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors">
              {{ c.name }}
            </button>
            <div *ngIf="clientFilterOptions.length === 0" class="px-4 py-3 text-sm text-slate-400 text-center">ไม่พบร้าน</div>
          </div>
        </div>
        <select [ngModel]="filterStatus()" (ngModelChange)="filterStatus.set($event); onFilterChange()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 min-w-[140px] h-[46px]">
          <option *ngFor="let o of statusOptions" [value]="o.value">{{ o.label }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-10 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">เลขบัตร</th>
            <th class="p-4">ชื่อผู้ถือบัตร</th>
            <th class="p-4">ร้าน</th>
            <th class="p-4">ประเภทบัตร</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4">เริ่ม-สิ้นสุด</th>
            <th class="p-4 text-center w-[140px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let item of items(); trackBy: trackById" (click)="openView(item)"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 cursor-pointer transition-colors">
            <td class="p-4 font-mono text-xs font-semibold">{{ item.cardName }}</td>
            <td class="p-4 font-medium">{{ item.name }}</td>
            <td class="p-4">{{ item.clientName }}</td>
            <td class="p-4 text-sm">{{ item.cardTypeName }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="{
                  'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': item.platformCardStatus === 'active',
                  'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': item.platformCardStatus === 'not_ready',
                  'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300': item.platformCardStatus === 'revoked',
                  'bg-slate-100 text-slate-500 dark:bg-slate-800': item.platformCardStatus !== 'active' && item.platformCardStatus !== 'not_ready' && item.platformCardStatus !== 'revoked'
                }">
                {{ statusLabel(item.platformCardStatus) }}
              </span>
            </td>
            <td class="p-4 text-xs whitespace-nowrap">
              {{ item.issueDate | date:'dd/MM/yyyy' }} - {{ item.expireDate | date:'dd/MM/yyyy' }}
            </td>
            <td class="p-4 text-center" (click)="$event.stopPropagation()">
              <div class="flex items-center justify-center gap-1.5">
                <button *ngIf="canUpdate && isCardEditable(item)" (click)="openVehicles(item)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30 hover:bg-emerald-500 hover:text-white transition-all"
                  title="แก้ไขทะเบียนรถ">
                  <span class="material-icons text-[18px]">directions_car</span>
                </button>
                <button *ngIf="canUpdate && isCardEditable(item)" (click)="openEdit(item)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-600 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 hover:text-white transition-all"
                  title="แก้ไขข้อมูลบัตร">
                  <span class="material-icons text-[18px]">edit</span>
                </button>
                <button *ngIf="canDelete && item.platformCardStatus !== 'revoked'" (click)="revokeCard(item, $event)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-rose-500 bg-rose-50 dark:bg-rose-900/30 hover:bg-rose-500 hover:text-white transition-all"
                  title="ยกเลิกและคืนโควต้า">
                  <span class="material-icons text-[18px]">cancel</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="7" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block">search_off</span>
              {{ selectedSiteId ? 'ยังไม่มีบัตร quota — กดออกบัตรเพื่อเริ่ม' : 'กรุณาเลือกลาน' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
          [ngClass]="p === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">{{ p }}</button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>

<app-modal-parking-card-detail *ngIf="isModalOpen()" [siteId]="selectedSiteId" [userId]="issueUserId"
  [cardId]="selectedCardId" [initialClientId]="initialClientIdForModal" [mode]="modalMode"
  [initialActiveTab]="modalInitialTab" (close)="closeModal()" (saved)="onCardSaved()"></app-modal-parking-card-detail>

<app-pss-confirm-modal *ngIf="isRevokeConfirmOpen()" title="ยืนยันการยกเลิกบัตร?" message="ยกเลิกบัตร"
  [highlight]="revokeTarget()?.cardName || ''" messageSuffix="และคืนโควต้าหรือไม่?" confirmLabel="ยกเลิกบัตร"
  icon="cancel" variant="danger" (confirm)="confirmRevokeCard()" (cancel)="closeRevokeConfirm()">
</app-pss-confirm-modal>
